function camelToCapitalizeText(camelString: string): string {
    const words: string[] = camelString.split(/(?=[A-Z])/);
    const capitalizedWords: string[] = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
    const capitalizedText: string = capitalizedWords.join(" ");
    return capitalizedText;
}

export default camelToCapitalizeText;
